import {useActionContext} from "@context/actionContext/hooks/useActionContext";

export function useSnackBar() {

    const {setSnackBar: setSnackBarGlobal} = useActionContext()

    const setSnackBar = ({message, variant = 'success', title = ''}: {
        message?: string,
        variant?: 'success' | 'error' | 'warning' | 'info',
        title?: string,
    }) => {
        setSnackBarGlobal({
            message, title, variant, open: true
        })
    };
    return {
        setSnackBar
    }
}